import { Box, Breadcrumbs, Paper, Typography } from "@mui/material";
import { getBulkNonRecurring, nonRecurringProfileBulkUpdate, recurringProfileBulkUpdate, taskBulkUpdate } from "api/services/tasks/tasks";
import { snack } from "components/toast";
import { usePermissions } from "context/PermissionsProvider";
import useTitle from "hooks/useTitle";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { handleError } from "utils/handleError";
import AccessDenied from "views/atom-pro/Access/accessDenide";
import ErrorsModal from "views/bulk-edit/NonRecurringBulkEdit/ErrorsModal";
import Filters from "views/bulk-edit/NonRecurringBulkEdit/Filters";
import HandleSelectedField from "views/bulk-edit/NonRecurringBulkEdit/HandleSelectedField";
import Report from "views/bulk-edit/NonRecurringBulkEdit/Report";
import { Permissions } from "data/permissons";
import { useUserData } from "context/UserProfile";

export interface IState {
  client: any;
  members: any;
  taskLeader: any;
  partner: any;
  approvalUser: any;
  labels: any;
  priority: Array<any>;
  billingType: "ALL" | "BILLABLE" | "NON_BILLABLE";
  taskServiceType: "ALL" | "STANDARD" | "CUSTOM";
  category: any;
  subCategory: any;
  selectedField: "" | string;
  existingValue: any;
  newValue: any;
  newMembers: any[];
  newTaskLeaders: Array<any>;
  newPartner: any;
  newLabels: Array<any>;
  service: any;
  showMore: Boolean;
  approvalProcedures: any;
  udinTask: any,
  frequency: any,
  recurringDetails: any,
  existingUser: any;
  newUser: any;
  financialYear: string;
}

function NonRecurringBulkEdit() {
  useTitle("Upcoming Non Recurring Bulk Activity");
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();
  const startYear = currentMonth >= 3 ? currentYear : currentYear - 1;
  const financialYear = `${startYear}-${startYear + 1}`;
  const { permissions } = usePermissions();
  const { data: userData } = useUserData();
  const [data, setData] = useState(null);
  const [state, setState] = useState<IState>({
    client: null,
    members: null,
    taskLeader: null,
    partner: null,
    approvalUser: null,
    labels: null,
    priority: [],
    billingType: "ALL",
    taskServiceType: "ALL",
    category: null,
    subCategory: null,
    selectedField: "",
    existingValue: null,
    newValue: null,
    newTaskLeaders: [],
    newMembers: [],
    newPartner: null,
    newLabels: [],
    service: null,
    showMore: false,
    approvalProcedures: null,
    udinTask: null,
    frequency: null,
    recurringDetails: null,
    existingUser: null,
    newUser: null,
    financialYear: financialYear
  });

  const initialState: IState = {
    client: null,
    members: null,
    taskLeader: null,
    partner: null,
    approvalUser: null,
    labels: null,
    priority: [],
    billingType: "ALL",
    taskServiceType: "ALL",
    category: null,
    subCategory: null,
    selectedField: "",
    existingValue: null,
    newValue: null,
    newTaskLeaders: [],
    newMembers: [],
    newPartner: null,
    newLabels: [],
    service: null,
    showMore: false,
    approvalProcedures: [],
    udinTask: null,
    frequency: null,
    recurringDetails: null,
    existingUser: null,
    newUser: null,
    financialYear: financialYear
  }
  const [errorsList, setErrorsList] = useState<any[]>([]);
  const [offset, setOffset] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  const [selected, setSelected] = useState<any[]>([]);
  const [sucessCount, setSucessCount] = useState<number>(0);
  const [failCount, setFailCount] = useState<number>(0);

  const { mutate, isLoading, isError } = useMutation(getBulkNonRecurring, {
    onSuccess: (res: any) => {
      setData(res?.data);
    },
    onError: (err: any) => {
      snack.error(handleError(err));
    },
  });
  const handleSubmit = () => {
    if (!state.members && !state.client && (!state.taskLeader || state.taskLeader === "NA") && (!state.approvalUser || state.approvalUser === "NA")) return snack.error("Please Select atleast Client/Clients Group or Assignee Or Task Leader or Approval User ! ");
    mutate({
      ...state,
      client: state.client?.id,
      clientType: state.client?.type,
      members: state.members?.id,
      approvalUser: state?.approvalUser?.id,
      taskLeader: state.taskLeader === "NA" ? "NA" : state.taskLeader?.id,
      partner: state.partner?.id,
      category: state.category?.id,
      subCategory: state.subCategory?.id,
      selectedField: state.selectedField,
      priority: state.priority?.map((item) => item.value),
      service: state.service?.id,
      offset,
      limit,
    });
  };

  useEffect(() => {
    if (state.members) {
      handleSubmit();
    }
  }, [limit, offset])

  const { mutate: bulkUpdateMutation, isLoading: bulkUpdationLoading } = useMutation(nonRecurringProfileBulkUpdate, {
    onSuccess: (res: any) => {
      setErrorsList(res?.data?.errorsListArray)
      setFailCount(res?.data?.errorsListArray?.length)
      if (res.data?.validTaskIdsArray?.length > 0) {
        setData(null);
        snack.success(`${res.data?.validTaskIdsArray?.length} Task(s) Updated`);
        setSucessCount(res.data?.validTaskIdsArray?.length);
      } else if (res.data?.validTaskIdsArray?.length === 0) {
        snack.error('No Valid Tasks To update')
      }
      setSelected([])
    },
    onError: (err: any) => {
      snack.error(handleError(err));
      setSelected([])
    },
  });

  const handleViewMore = () => {
    setState((prevState) => ({
      ...prevState,
      showMore: !prevState.showMore,
    }));
  };

  const handlePageChange = (page: number) => {
    setOffset(page * limit);
  };

  const handleLimitChange = (newLimit: number) => {
    setLimit(newLimit);
    setOffset(0);
  };

  const onBulkUpdate = (selected) => {
    if (state.selectedField === "start_date" && !state.newValue) {
      return snack.error("Please Select Start Date !")
    }
    if (state.selectedField === "due_date" && !state.newValue) {
      return snack.error("Please Select Due Date !")
    }
    if (state.selectedField === "expected_completion_date" && !state.newValue) {
      return snack.error("Please Select Expected Completion Date !")
    }
    if (state.selectedField === "priority" && !state.newValue) {
      return snack.error("Please Select Priority !")
    }
    if (state.selectedField === "add_user" && !state.newMembers.length) {
      return snack.error("Please Select Users !")
    }
    if (state.selectedField === "update_user" && !state.newMembers.length) {
      return snack.error("Please Select Users !")
    }
    if (state.selectedField === "remove_user" && !state.newMembers.length) {
      return snack.error("Please Select Users !")
    }
    if (state.selectedField === "add_task_leader" && !state.newTaskLeaders.length) {
      return snack.error("Please Select Task Leader !")
    }
    if (state.selectedField === "update_task_leader" && !state.newTaskLeaders.length) {
      return snack.error("Please Select Task Leader !")
    }
    if (state.selectedField === "remove_task_leader" && !state.newTaskLeaders.length) {
      return snack.error("Please Select Task Leader !")
    }
    if (state.selectedField === "add_partner" && !state.newPartner) {
      return snack.error("Please Select Partner !")
    }
    if (state.selectedField === "update_partner" && !state.newPartner) {
      return snack.error("Please Select Partner !")
    }
    if (state.selectedField === "remove_partner" && !state.newPartner) {
      return snack.error("Please Select Partner !")
    }
    if (state.selectedField === "update_new_with_existing_user" && (!state.newUser || !state.existingUser)) {
      return snack.error("Please Select Users !")
    }
    bulkUpdateMutation({
      ids: selected.map((c: any) => c.id),
      selectedField: state.selectedField ? state.selectedField : null,
      newMembers: state.newMembers?.map((user) => user),
      newValue: state?.newValue ? state.newValue : null,
      newTaskLeaders: state.newTaskLeaders?.map((leader) => leader),
      newPartner: state.newPartner?.id ? state.newPartner.id : null,
      newLabels: state.newLabels?.map((label) => label),
      udinTask: state.udinTask ? true : false,
      recurringDetails: state.recurringDetails ? state?.recurringDetails : null,
      existingUser: state.existingUser ? state.existingUser : null,
      newUser: state.newUser ? state.newUser : null,
    });
  }

  const clearFilters = () => {
    setState(initialState);
    setData(null);
  }

  if (userData?.role?.name !== "Admin" && !(permissions.includes(Permissions.VIEW_ALL_TASKS) || permissions.includes(Permissions.VIEW_ASSIGNED_TASKS))) {
    return <AccessDenied />
  }

  return (
    <Box p={2} >
      <Filters state={state} isloading={isLoading} setState={setState} onSubmit={handleSubmit} clearFilters={clearFilters} handleViewMore={handleViewMore} setData={setData} initialState={initialState} />
      <HandleSelectedField state={state} isloading={isLoading} setState={setState} onSubmit={handleSubmit} />
      <Report isLoading={isLoading} isError={isError} state={state} setState={setState} data={data} onBulkUpdate={onBulkUpdate} limit={limit} offset={offset} handleLimitChange={handleLimitChange} handlePageChange={handlePageChange} selected={selected} setSelected={setSelected} bulkUpdationLoading={bulkUpdationLoading} handleSubmit={handleSubmit} />
      <ErrorsModal errorsList={errorsList} onClose={() => setErrorsList([])} sucessCount={sucessCount} failCount={failCount} />
    </Box>
  );
}

export default NonRecurringBulkEdit;
